export default "__VITE_ASSET__QcpjtmUd__ 640w, __VITE_ASSET__TwPRxMMe__ 1024w";